import { PaymentApiClientURLs, PaymentApiClientInterface } from '@/models/api-client/payment'
import { PaymentApiClient } from './PaymentApiClient'
import { paymentEndpointConstants } from '@/constants/endpoint'

const urls: PaymentApiClientURLs = {
  repaymentScheduleURL: paymentEndpointConstants.REPAYMENT_SCHEDULE,
  getCardDetailsURL: paymentEndpointConstants.GET_CARD_DETAILS,
  downPaymentURL: paymentEndpointConstants.DOWN_PAYMENT
}

const paymentApiClient: PaymentApiClientInterface = new PaymentApiClient(urls)

export default paymentApiClient
